"use client";

import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Image from "next/image";
import CounterFIrst from "../../../public/assets/counters/years-experience.png";
import CounterSec from "../../../public/assets/counters/countries.png";
import CounterThrd from "../../../public/assets/counters/manufacturing.png";
import CounterFrth from "../../../public/assets/counters/bottle.png";
import CounterFth from "../../../public/assets/counter_fifth.png";
import Countersth from "../../../public/assets/counter_sth.png";
gsap.registerPlugin(ScrollTrigger);

// const counterData = [
//   { label: "Satisfied Clients", value: 500, suffix: "+" },
//   { label: "Years of Experience", value: 12, suffix: "+" },
//   { label: "Projects", value: 1, suffix: "K" },
//   { label: "Awards", value: 34, suffix: "" },
// ];

const Counter = () => {
  // const countersRef = useRef<Array<HTMLSpanElement | null>>([]);

  // useGSAP(() => {
  //   countersRef.current.forEach((el, index) => {
  //     const finalValue = counterData[index].value;
  //     const suffix = counterData[index].suffix || "";
  //     const obj = { val: 0 };

  //     gsap.to(obj, {
  //       val: finalValue,
  //       duration: 2,
  //       ease: "power3.out",
  //       scrollTrigger: {
  //         trigger: el,
  //         start: "top 80%",
  //         toggleActions: "play none none none",
  //       },
  //       onUpdate: () => {
  //         if (el) {
  //           el.textContent = Math.floor(obj.val).toString() + suffix;
  //         }
  //       },
  //     });
  //   });
  // }, []);

  return (
    <section className="relative py-[50px] px-[10px]">
      <div className="container mx-auto">
           <h2 className="title !text-center !mb-5 xl:!mb-12 !text-[#033b6f]">
          Emerge <span className="text-[#d42427]"> at</span> Glance
        </h2>

        <div className="grid xl:grid-cols-5 grid-cols-2 xl:gap-6 gap-3">
          {/* {counterData.map((item, i) => (
            <div key={i} className=" p-5 group">
              <div className="xl:w-[180px] bg-gray-100  w-30 xl:h-[180px] h-30  relative counter-border ">
                <span
                  ref={(el) => {
                    countersRef.current[i] = el;
                  }}
                  className="xl:text-5xl text-xl font-medium text-[#282930] "
                >
                  0
                </span>
              </div>
              <p className="text-base text-center font-semibold tracking-wide text-[#282930] mt-10 uppercase">
                {item.label}
              </p>
            </div>
          ))} */}

          <Image
            src={CounterFIrst}
            alt="Years Experience"
            className="drop-shadow-2xl"
          />
          <Image src={CounterSec} alt="Countries" className="drop-shadow-2xl" />
          {/* <Image
            src={CounterThrd}
            alt="Manufacturing"
            className="drop-shadow-2xl"
          /> */}
          <Image src={CounterFrth} alt="Bottle" className="drop-shadow-2xl" />
          <Image src={CounterFth} alt="Bottle" className="drop-shadow-2xl" />
          <Image src={Countersth} alt="Bottle" className="drop-shadow-2xl" />
        </div>
      </div>
    </section>
  );
};

export default Counter;
